import { atom } from "recoil";

export const refetchAllBrandAdminUsersAtomState = atom({
    key: '18a41c18-de39-4cb3-889b-115829b7148c', // unique ID (with respect to other atoms/selectors)
    default: { "RefetchBrandAdminUsers": "" },
});
